import React from "react";
import { Routes as AppRoutes, Route } from 'react-router-dom';

import Home from '../Components/Home';
import FellowshipProgramme from '../Components/FellowshipProgramme';
import Scope from '../Components/Scope';
import SalientFeatures from '../Components/SalientFeatures';
import InternationalJury from '../Components/InternationalJury';
import Fellows from '../Components/Fellows';
import ImportantDates from '../Components/ImportantDates';
import SelectionProcess from '../Components/SelectionProcess';
import Instructions from '../Components/Instructions';
import FAQs from '../Components/FAQs';
import PrivacyNotice from '../Components/PrivacyNotice';
import TermsOfUse from '../Components/TermsOfUse';
import Auth from "../Components/Auth";
import UserHome from "../Components/User/Home";
import Proposal from "../Components/User/Proposal";
import Qpr from "../Components/User/Qpr";
import Profile from "../Components/User/Profile";
import Team from "../Components/User/Team";
import Login from "../Components/Auth/Login";

const Routes = () => {
  return (
    <>
      <AppRoutes>
        <Route exact path='/' element={<Home />} />
        {/* <Route exact path='/fellowship-programme' element={<FellowshipProgramme />} />
        <Route exact path='/scope' element={<Scope />} />
        <Route exact path='/salient-features' element={<SalientFeatures />} />
        <Route exact path='/international-jury' element={<InternationalJury.Home />} />
        <Route exact path='/international-jury/charlotte-benson' element={<InternationalJury.CharlotteBenson />} />
        <Route exact path='/international-jury/jim-hall' element={<InternationalJury.JimHall />} />
        <Route exact path='/international-jury/marjorie-greene' element={<InternationalJury.MarjorieGreene />} />
        <Route exact path='/international-jury/ravi-sinha' element={<InternationalJury.RaviSinha />} />
        <Route exact path='/international-jury/satoru-nishikawa' element={<InternationalJury.SatoruNishikawa />} />
        <Route exact path='/international-jury/deepali-khanna' element={<InternationalJury.DeepaliKhanna />} />
        <Route exact path='/fellows-2021-2022' element={<Fellows.Fellows20212022.Home />} />
        <Route exact path='/fellows-2021-2022/convocation' element={<Fellows.Fellows20212022.Convocation />} />
        <Route exact path='/fellows-2021-2022/convocation/gallery' element={<Fellows.Fellows20212022.Gallery />} />
        <Route exact path='/fellows-2022-2023' element={<Fellows.Fellows20222023.Home />} />
        <Route exact path='/fellows-2023-2024' element={<Fellows.Fellows20232024.Home />} />
        <Route exact path='/important-dates' element={<ImportantDates />} />
        <Route exact path='/selection-process' element={<SelectionProcess />} />
        <Route exact path='/instructions' element={<Instructions />} />
        <Route exact path='/faqs' element={<FAQs />} />
        <Route exact path='/privacy-notice' element={<PrivacyNotice />} />
        <Route exact path='/terms-of-use' element={<TermsOfUse />} /> */}
        <Route exact path='/register' element={<Auth.Register />} />
        <Route exact path='/login' element={<Auth.Login />} />
        <Route exact path='/logout' element={<Auth.Logout />} />
        <Route exact path='/forget-password' element={<Auth.ForgetPassword />} />
        <Route exact path='/reset-password' element={<Auth.ResetPassword />} />

        <Route exact path='/user/profile/show' element={<Profile.Show />} />
        <Route exact path='/user/profile/edit' element={<Profile.Edit />} />
        <Route exact path='/user/team' element={<Team.List />} />
        <Route exact path='/user/team/add' element={<Team.Add />} />
        <Route exact path='/user/team/edit' element={<Team.Edit />} />
        
        <Route exact path='/user/home' element={<UserHome />} />
        {/* <Route exact path='/user/home' element={<Qpr.Home />} /> */}
        <Route exact path='/user/proposals' element={<Proposal.List />} />
        <Route exact path='/user/proposal/detail' element={<Proposal.Detail />} />

        <Route exact path='/user/qpr/add/basic-information' element={<Qpr.BasicInfromationForm />} />
        <Route exact path='/user/qpr/add/research-background' element={<Qpr.ResearchBackgroundForm />} />
        <Route exact path='/user/qpr/add/response-to-te' element={<Qpr.ResponseToTEForm />} />
        <Route exact path='/user/qpr/add/progress-report' element={<Qpr.ProgressReportForm />} />
        <Route exact path='/user/qpr/add/progress-ppt' element={<Qpr.ProgressPPTForm />} />
        <Route exact path='/user/qpr/add/plan-for-remaining-quarter' element={<Qpr.PlanForRemainingQuarterForm />} />
        <Route exact path='/user/qpr/add/project-gantt-chart' element={<Qpr.ProjectGanttChartForm />} />
        <Route exact path='/user/qpr/add/submit' element={<Qpr.SubmitForm />} />
        <Route exact path='/user/qpr/show' element={<Qpr.Show />} />

      </AppRoutes>
    </>
  );
}

export default Routes;